export var TransitionType;

(function (TransitionType) {
  TransitionType[TransitionType["REPAINT"] = 0] = "REPAINT";
})(TransitionType || (TransitionType = {}));